

export default class Component {
  constructor({ container, elements }) {
    this.container = container instanceof HTMLElement ? container : document.querySelector(container)

    this.elements = {}
    this.selectors = {
      ...elements
    }

    this.create()
  }

  create() {
    for (const [key, selector] of Object.entries(this.selectors)) {
      if (selector instanceof HTMLElement || selector instanceof NodeList) {
        this.elements[key] = selector
      } else {
        this.elements[key] = document.querySelectorAll(selector)

        if (this.elements[key].length === 1) {
          this.elements[key] = document.querySelector(selector)
        } else if (this.elements[key].length === 0) {
          this.elements[key] = null
        }
      }
    }

  }

  // addEventListeners() {

  // }

  // removeEventListeners() {

  // }
}
